import PropTypes from 'prop-types';
import React from 'react';

import { GenericTextSection } from './GenericTextSection';

export class TutorFeedback extends React.Component {
  render() {
    const { feedbackText, tutorName } = this.props;
    return (
      <GenericTextSection
        text={feedbackText}
        title="Tutor feedback"
        messageWhenEmpty={`${tutorName} did not provide any feedback for the session.`}
      />
    );
  }
}

TutorFeedback.propTypes = {
  feedbackText: PropTypes.string,
  tutorName: PropTypes.string.isRequired,
};

TutorFeedback.defaultProps = {
  feedbackText: null,
};
